export default __webpack_public_path__ + "static/media/placeholder.675c4408.svg";